module.exports = __webpack_public_path__ + "static/media/microphone.060f6e2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/microphone.svg
// module id = 116
// module chunks = 0